var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMhubAccounts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.937,2.814H6.063A4.078,4.078,0,0,0,1.989,6.888V17.112a4.078,4.078,0,0,0,4.074,4.074H17.937a4.078,4.078,0,0,0,4.074-4.074V6.888A4.078,4.078,0,0,0,17.937,2.814Zm2.574,14.3a2.577,2.577,0,0,1-2.574,2.574H6.063a2.577,2.577,0,0,1-2.574-2.574V6.888A2.577,2.577,0,0,1,6.063,4.314H17.937a2.578,2.578,0,0,1,2.574,2.574Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.54 15.178 8.608 12.11 5.54 12.11 5.54 15.178"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.896 15.178 11.896 12.11 8.828 12.11 11.896 15.178"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.104 15.178 15.172 12.11 12.104 12.11 12.104 15.178"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.46 15.178 18.46 12.11 15.392 12.11 18.46 15.178"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.608 11.89 8.608 8.822 5.54 11.89 8.608 11.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.172 11.89 15.172 8.822 12.104 11.89 15.172 11.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.828 11.89 11.896 11.89 8.828 8.822 8.828 11.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.392 11.89 18.46 11.89 15.392 8.822 15.392 11.89"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhubAccounts);
export default __webpack_public_path__ + "static/media/mhub_accounts.358f8595.svg";
export { ForwardRef as ReactComponent };